export default () => ({
    data: {},
    loading: false,
    error: null,
    categories: [],
    selectedCategory: null,
    recordedTalks: [],
    recordedTalksByCategory: {},
    favoriteRecordedTalks: [],
    selectedRecordedTalk: null,
    categoriesLoading: false,
    talksLoading: false,
    lastUpcomingTalk: null,
    lastUpcomingTalkLoading: false
}) 